export enum AmortizationType {
    FIXED = 'FIXED',
    ADJUSTABLE = 'ADJUSTABLE'
}

export const amortizationTypeDisplay = {
    [AmortizationType.FIXED]: 'Fixed',
    [AmortizationType.ADJUSTABLE]: 'Adjustable'
};
